import script from "./PaperDetection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaperDetection.vue?vue&type=script&setup=true&lang=ts"

import "../style/PaperDetection.css?vue&type=style&index=0&id=c2e75c7c&scoped=true&lang=css&external"
import "./PaperDetection.vue?vue&type=style&index=1&id=c2e75c7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e75c7c"]])

export default __exports__